import { useEffect, useState } from "react";

export function ProgressBar({ percent = 0, expectedPercent = 0, color = "ok", testId, showMarker = true }) {
  const [animated, setAnimated] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setAnimated(percent), 60);
    return () => clearTimeout(t);
  }, [percent]);

  return (
    <div className="bar-track" data-testid={testId}>
      <div
        className={`bar-fill ${color}`}
        style={{ width: `${animated}%` }}
      />
      {showMarker && expectedPercent > 0 && expectedPercent < 100 && (
        <div
          className="bar-marker"
          style={{ left: `${expectedPercent}%` }}
          title={`Attendu: ${expectedPercent}%`}
        />
      )}
    </div>
  );
}

const COLOR_META = {
  ok: { dot: "bg-[var(--ok)]", label: "À jour" },
  just: { dot: "bg-[var(--just)]", label: "Juste" },
  late: { dot: "bg-[var(--late)]", label: "En retard" },
};

export function ColorDot({ color }) {
  const meta = COLOR_META[color] || COLOR_META.late;
  return <span className={`inline-block w-2 h-2 ${meta.dot}`} />;
}

export function colorLabel(color) {
  return (COLOR_META[color] || COLOR_META.late).label;
}
